<div class="flex flex-col min-h-full">
  <l-list-header title="Perfil"></l-list-header>

  <l-crud-container [formGroup]="form" (ngSubmit)="submit()">
    <div class="grid gap-5 grid-cols-12">
      <div class="col-span-6">
        <label class="subtext-color text-sm">Nome</label>
        <input class="mt-2" formControlName="name" lInput placeholder="Nome">
      </div>

      <div class="col-span-6">
        <label class="subtext-color text-sm">E-mail</label>
        <input class="mt-2" formControlName="email" lInput placeholder="E-mail">
      </div>

      <div class="col-span-12">
        <label class="subtext-color text-sm">Senha</label>
        <input class="mt-2" formControlName="email" lInput placeholder="Senha">
      </div>
    </div>

    <div class="flex justify-end w-full mt-auto pt-5 gap-5">
      <button class="w-min" lButton [disabled]="isSubmitting" (click)="return()">
        Cancelar
      </button>

      <button
        [pTooltip]="globalError || ''"
        class="w-min gap-2"
        lButton
        [bType]="isSubmitting ? 'disabled' : 'primary'"
        type="submit"
        [disabled]="isSubmitting"
      >
        @if (isSubmitting) {
          <l-spinner [color]="spinnerColorEnum.WHITE" [size]="spinnerSizeEnum.SMALL" />
        }
        Salvar
      </button>
    </div>
  </l-crud-container>
</div>
